import { render, staticRenderFns } from "./LegendTipModal.vue?vue&type=template&id=40fe5688&scoped=true&"
import script from "./LegendTipModal.vue?vue&type=script&lang=js&"
export * from "./LegendTipModal.vue?vue&type=script&lang=js&"
import style0 from "./LegendTipModal.vue?vue&type=style&index=0&id=40fe5688&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.9.6_kq6vcxhoovkpo5ecbydii27d4a/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40fe5688",
  null
  
)

export default component.exports